/* @flow */

/* TODO: Resolve this! $FlowFixMe */
import actionTypes, { Type } from '../actions/types';

export const INITIAL_STATE = {
  orders: { isRequesting: false },
};

export const reducer = (state: Object, action: Type) => {
  switch (action.type) {
    case actionTypes.PLACE_ORDER_START:
      return { ...state, orders: { isRequesting: true } };
    case actionTypes.PLACE_ORDER_SUCCESS:
      return { ...state, orders: { isRequesting: false } };
    case actionTypes.PLACE_ORDER_FAILED:
      return { ...state, orders: { isRequesting: false } };
    default:
      return state;
  }
};
